import { useEffect, useState } from "react";
import { request } from "./network/Request";


export const TopRank = () => {
    const [activeTab, setActiveTab] = useState("145m(M)");
    const [scoreArray, setScoreArray] = useState([]);

    useEffect(() => {
        request({
            "bk-working": "score-list",
            type: "PRE",
            distance: activeTab.replace(/[^0-9]/g, ''),
            gender: activeTab.match(/\((.*?)\)/g)[0].replace("(", "").replace(")", ""),
        }).then(({ result, response }) => {
            if (result) {
                console.log(response);
                let scoreArray = response["score_array"];
                scoreArray.map((item) => {
                    let scoreMap = {};
                    var total = 0;
                    let turnArray = item.turn_concat.split(",");
                    let scoreArray = item.score_concat.split(",");

                    for (var i = 0; i < turnArray.length; i++) {
                        scoreMap[[turnArray[i]]] = scoreArray[i];
                        total += parseInt(scoreArray[i]);
                    }

                    item["score_map"] = scoreMap;
                    item["total"] = total;
                });

                let sorted = scoreArray
                  .sort((a, b) => {
                    console.log(a.total, b.total);
                    return a.total > b.total ? -1 : a.total < b.total ? 1 : 0;
                  })
                  .slice(0, 3);
                setScoreArray(sorted);
                console.log(sorted);
            }
        });
    }, [activeTab]);

    const tabs = [
        "145m(M)",
        "145m(F)",
        "90m(M)",
        "90m(F)",
        "70m(M)",
        "70m(F)",
        "30m(M)",
        "30m(F)"
    ];

    return (
        <div className="topRank">
            <div className="topRankInner">

                {/* 탭 버튼 영역 */}
                <div className="topRankTab">
                    <ul>
                        {tabs.map((tab) => (
                            <li
                                key={tab}
                                className={activeTab === tab ? "active" : ""}
                                onClick={() => setActiveTab(tab)}
                            >
                                {tab}
                            </li>
                        ))}
                    </ul>
                </div>

                {/* 탭 컨텐츠 영역 */}
                <div className="topRankSection">
                    {tabs.map((tab) => (
                        <div
                            key={tab}
                            className={`topRankCon ${activeTab === tab ? "show" : "hide"
                                }`}
                        >
                            <div className="topRankCa">{tab}</div>
                            <div className="topRankList">
                                <div className="topRankDes">
                                    <p className="topRankDes1">Ranking</p>
                                    <p className="topRankDes2">Name</p>
                                    <p className="topRankDes3">Country</p>
                                    <p className="topRankDes4">Score</p>
                                </div>
                                <ul>
                                    {scoreArray.map((p, index) => (
                                        <li key={index}>
                                            <p className="playerRank">{index + 1}</p>
                                            <p className="playerName"><span>{p.player_name}</span></p>
                                            <p className="playerCountry">{p.country}</p>
                                            <p className="playerScore">{p.total}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};
